import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '@env/environment'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class ChangeUploadTitleCommand {
  constructor(private httpClient: HttpClient) {}

  call(organizationId: number, uuid: string, title: string): Observable<any> {
    const url = `${environment.api.screenRecorder}/organizations/${organizationId}/uploads/${uuid}/change_title`
    const params = new FormData()

    params.append('title', title)

    return this.httpClient.post(url, params)
  }
}
